// extracted by mini-css-extract-plugin
export default {"Container":"Gallery_Container__9rXZN","Dropzone":"Gallery_Dropzone__D9ggl"};